import { render, staticRenderFns } from "./competeProjectManagement.vue?vue&type=template&id=3ddf0188&"
import script from "./competeProjectManagement.vue?vue&type=script&lang=js&"
export * from "./competeProjectManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports